import React from 'react';
import InviteDesigners from '../../components/InviteDesignersPage';
import { StepType } from '../../util/step';
import BriefWizard from '../BriefWizard';
import { StructuredBriefFragment } from './DynamicBrief.generated';
import { createSteps } from './Step';
import { Summary } from './Summary';

// Pre-purchased product that only allows selection of a single designer
export function BundledRequestQuoteBriefWizard({
    brief,
    formData,
    refetch,
    currentStep,
}: {
    brief: StructuredBriefFragment;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formData: Record<string, any>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    refetch: (options: { id: string }) => Promise<any>;
    currentStep: number;
}) {
    const isInBundle = (brief.order?.items?.length ?? 0) > 1;
    const noPaymentRequiredHeading = isInBundle
        ? __('Already purchased with your Logo + Squarespace bundle')
        : __('Already purchased');

    return (
        <BriefWizard
            refetch={refetch}
            brief={brief}
            formData={formData}
            schema={brief.schemaId}
            disableContacts
            totalAllowableDesigners={1}
            briefProduct={brief.product}
            order={brief.order}
            jobId={brief.job?.id}
            postPaymentRedirect="job" // anything that comes through here is a job
            noPaymentRequiredHeading={noPaymentRequiredHeading}
            currentStep={currentStep}
            steps={createSteps(brief, [
                {
                    title: __('Review your brief'),
                    render: () => <Summary brief={brief} />,
                },
                {
                    title: __('Choose a designer'),
                    isAuthRequired: true,
                    stepType: StepType.Designer,
                    nextActionLabel: __('Confirm designer'),
                    render: () => (
                        <InviteDesigners
                            brief={brief}
                            description={__(
                                'We’ve matched you with these awesome designers. Select your favourite one to work with.'
                            )}
                        />
                    ),
                },
            ])}
        />
    );
}
